import { useEffect, useMemo, useRef } from 'react';

import { SalesOrderInfo } from '../../../store/slices/salesOrders';
import classes from './DocumentsTab.module.css';
import { IDocument, fetchDocuments, selectDocuments } from '../../../store/slices/documents';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import plusIcon from '../../../assets/icons/plus-icon.svg';

import { toast } from 'react-toastify';
import { isFileTypeAllowed } from '../../../utils/miscUtils';
import { DocumentList } from '../../../components/DocumentList/DocumentList';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  selectedSalesOrder?: SalesOrderInfo;
  canEditConsultation?: boolean;
};

const DocumentsTab: React.FC<Props> = ({ selectedSalesOrder, canEditConsultation }) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const documents: IDocument[] = useAppSelector<IDocument[]>(selectDocuments);
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const documentsDisplayed = useMemo(() => {
    return documents;
  }, [documents]);

  useEffect(() => {
    dispatch(
      fetchDocuments({
        salesOrderId: selectedSalesOrder?.sales_order.sales_order_id ?? 0,
        salesOrderItemId: selectedSalesOrder?.sales_order_item.sales_order_item_id ?? 0,
      })
    );
  }, [dispatch, selectedSalesOrder]);

  const onFileChangeHandler = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      if (!isFileTypeAllowed(file.type)) {
        toast.error(translations('not.allowed.type'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return;
      }
    }
  };

  const uploadButtonHandler = () => {
    if (canEditConsultation === false) {
      toast.error(translations('not.allowed'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    hiddenFileInput?.current?.click();
  };

  return (
    <div className={classes.container}>
      {selectedSalesOrder?.work_order_service_consultation && (
        <>
          <div className={classes.documentsContainer}>
            <div className={classes.documentsHeader}>
              <div>
                <h2>{translations('documents')}</h2>
                <span>{translations('all.documents')}</span>
              </div>
              <div className={classes.headerButtons}>
                <div className={classes.fileUploadButton} onClick={() => uploadButtonHandler()}>
                  <div>
                    <img
                      src={plusIcon}
                      alt="plus"
                      onClick={() => {}}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <div>
                    <span>{translations('file.upload')}</span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className={classes.uploadedDocumentsTitle}>
                <h3>{translations('uploaded.documents')}</h3>
              </div>
              <DocumentList documents={documentsDisplayed ?? []} />
            </div>
          </div>

          {/*{isAddingNewDocument && (*/}
          {/*  <NewDocumentModal*/}
          {/*    isOpen={isAddingNewDocument}*/}
          {/*    onClose={() => {*/}
          {/*      setIsAddingNewDocument(false);*/}
          {/*      setSelectedFile(undefined);*/}
          {/*    }}*/}
          {/*    selectedSalesOrder={selectedSalesOrder}*/}
          {/*    variant="upload"*/}
          {/*    selectedFile={selectedFile!}*/}
          {/*  />*/}
          {/*)}*/}
          <input
            name="filename"
            type="file"
            ref={hiddenFileInput}
            style={{ display: 'none' }}
            onChange={onFileChangeHandler}
            accept="image/*,application/pdf"
          />
        </>
      )}
    </div>
  );
};

export default DocumentsTab;
